<template>
  <div
    id="data-list-list-view"
    class="mt-3 data-list-container flipthis-highlight vs-con-loading__container"
  >
    <paginacao-placeholder v-if="loading" />
    <template v-else>
      <vs-table
        ref="table"
        :sst="true"
        :data="cobrancas"
        @sort="handleOrdenacao"
        noDataText="Nenhum dado disponível com os filtros selecionados."
      >
        <template slot="thead" v-if="cobrancas.length">
          <vs-th>Competência</vs-th>
          <vs-th>Número da Proposta</vs-th>
          <vs-th>Nome do Cliente</vs-th>
          <vs-th>CPF do Cliente</vs-th>
          <vs-th>Forma Pagamento</vs-th>
          <vs-th>Valor</vs-th>
          <vs-th>Parcela</vs-th>
          <vs-th>Status</vs-th>
        </template>
        <template>
          <tbody>
            <vs-tr :data="cobranca" :key="indextr" v-for="(cobranca, indextr) in cobrancas">
              <vs-td>
                <p class="product-name font-medium main-menu-sidebar">{{ cobranca.competencia }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium main-menu-sidebar">{{ cobranca.contrato_id }}</p>
              </vs-td>
              <vs-td>
                <template v-if="cobranca.cliente">
                  <p class="product-name font-medium main-menu-sidebar">{{ cobranca.cliente.nome }}</p>
                </template>
              </vs-td>
              <vs-td>
                <template v-if="cobranca.cliente">
                  <p class="product-name font-medium main-menu-sidebar">{{ cobranca.cliente.cpf }}</p>
                </template>
              </vs-td>

              <vs-td>
                <template v-if="cobranca.formaPagamento">
                  <p class="product-category main-menu-sidebar">{{ cobranca.formaPagamento.nome }}</p>
                </template>
              </vs-td>

              <vs-td>
                <p class="product-category main-menu-sidebar">{{ cobranca.valor }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category main-menu-sidebar">{{ cobranca.parcela }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category main-menu-sidebar">{{ cobranca.status }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <paginacao :meta="meta" :handler="handlePaginaSelecionada" />
    </template>
  </div>
</template>

<script>
import DescontoStatus from "../components/StatusContrato";
import PaginacaoPlaceholder from "@/components/placeholders/PaginacaoPlaceholder";

export default {
  name: "paginacao-contratos",
  components: {
    DescontoStatus,
    PaginacaoPlaceholder
  },
  data() {
    return {
      cobrancas: [],
      meta: {},
      loading: false
    };
  },
  created() {
    this.buscarCobrancas(1);
  },
  watch: {
    $route(to) {
      this.buscarCobrancas(to.query.page);
    },
    loading(loading) {
      if (loading) {
        this.$vs.loading({
          container: "#data-list-list-view",
          scale: 0.6
        });
      } else {
        this.$vs.loading.close("#data-list-list-view > .con-vs-loading");
      }
    }
  },
  methods: {
    async buscarCobrancas(page) {
      this.loading = true;
      let response = await this.$store.getters.fetchCobrancas({
        page: page,
        status: this.$route.params.status,
        ...this.$route.query
      });

      if (response.data.status) {
        this.cobrancas = response.data.data;
        this.meta = response.data.meta;
      }
      console.log(this.cobrancas);
      this.loading = false;
    },
    handlePaginaSelecionada(query) {
      this.$router.push({
        name: "contratos",
        params: { status: this.$route.params.status },
        query
      });
    },
    handleOrdenacao(key, active) {
      this.$router.push({
        name: "contratos",
        params: { status: this.$route.params.status },
        query: {
          ...this.$route.query,
          sortedBy: active ? "asc" : "desc",
          orderBy: key,
          page: 1
        }
      });
    },
    copiarCpf(cpf) {
      this.$copyText(cpf);
      this.$vs.notify({
        title: "Sucesso",
        text: "CPF Foi copiado",
        position: "bottom-center"
      });
    },
    abrirDescontoVisualizar(cobranca) {
      this.$router.push({
        name: "visualizar-contrato",
        params: { id: cobranca.id }
      });
    }
  }
};
</script>
